import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../store/store";
import { login } from "../store/actions/authActions";
import { selectState, setError } from "../store/slices/authSlice";
import { ReactComponent as LightLogoElisyan } from "../assets/images/light_big_logo_elisyan.svg";
import "../assets/styles/index.css";
import CustomButton from "../components/CustomButton";
import useCustomStyles from "../hooks/useCustomStyles";
import { customStyles } from "../assets/styles/login";
import { setTheme, ThemeName } from "../store/slices/themeSlice";
import LogInSignUpInput from "../components/SignInInput";
import { selectTranslationState } from "../store/slices/languageSlice";
import { ReactComponent as LightLogoSopher } from "../assets/images/LOGO Sopher light mode 1.svg";
import { ReactComponent as LightLogoSopherAcounting } from "../assets/images/LOGO-Sopher-Accounting-light-mode.svg";
import { ReactComponent as LightLogoOlympe } from "../assets/images/logo-light-olympe.svg";
import { ReactComponent as LightLogoAurum } from "../assets/images/Aurum Logo login.svg";
import { ReactComponent as LightLogoAdamBenedict } from "../assets/images/AdamBenedict WhiteLogonobackground.svg";
import { getDashboardTheme } from "../store/actions/businessActions";

function Login() {
  const { t } = useSelector(selectTranslationState);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const { theme, activeTheme } = useSelector(
    (state: RootState) => state.theme_slice
  );
  const { user } = useSelector((state: RootState) => state.auth_slice);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { error, loading, isAuthenticated } = useSelector(selectState);
  const classes = useCustomStyles(customStyles, theme);

  const validate = () => {
    let isValid = true;

    if (!email) {
      setEmailError("Email is required.");
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setEmailError("Please enter a valid email.");
      isValid = false;
    } else {
      setEmailError(null);
    }

    if (!password) {
      setPasswordError("Password is required.");
      isValid = false;
    } else if (password.length < 6) {
      setPasswordError("Password must be at least 6 characters.");
      isValid = false;
    } else {
      setPasswordError(null);
    }
    return isValid;
  };

  const handleLogin = async () => {
    if (validate()) {
      await dispatch(login({ email, password }));
    }
  };

  /*useEffect(() => {
    if (isAuthenticated) {
      console.log("isauthenticated", isAuthenticated);
      dispatch(
        setTheme({
          theme: (user?.business?.name && ["sopher", "sopher-test"].includes(user?.business?.name) )? 'sopher' as ThemeName : "elisyan",
          mode: "light",
        })
      );
      navigate("/v2-playground"); // TEMP: v2 testing convenience — revert to navigate("/") when done
    }
  }, [isAuthenticated]);*/

  // useEffect(() => {
  //   if (isAuthenticated && user) {
  //     const newTheme =
  //       (user?.business?.name && ["sopher", "sopher-test"].includes(user?.business?.name))
  //         ? "sopher"
  //         : "elisyan";
  //     if (newTheme !== activeTheme) {
  //       dispatch(
  //         setTheme({
  //           theme: newTheme as ThemeName,
  //           mode: "light",
  //         })
  //       );
  //     }
  //     navigate("/");
  //   }
  // }, [isAuthenticated, user, activeTheme, dispatch]);

  useEffect(() => {
    console.log(user?.business?.name);
    if (isAuthenticated && user) {
      let newTheme: ThemeName = "elisyan"; // default

      switch (user?.business?.name) {
        case "sopher":
        case "sopher-test":
          newTheme = "sopher";
          break;

        // Add more cases here as needed
        case "SOPHER_ACCOUNTING":
        case "SOPHER_ACCOUNTING_TEST":
          newTheme = "sopheraccounting";
          break;

        case "OLYMPE":
        case "OLYMPE_TEST":
          newTheme = "olympe";
          break;

        case "aurum":
        case "aurum-test":
          newTheme = "aurum";
          break;
        case "Adam_Benedict":
        case "Adam_Benedict_Test":
          newTheme = "adambenedict";
          break;
        // ... other businesses

        default:
          newTheme = "elisyan";
      }

      // if (newTheme !== activeTheme) {
      //   dispatch(
      //     setTheme({
      //       theme: newTheme,
      //       mode: "light",
      //     })
      //   );
      // }

      navigate("/");
    }
  }, [isAuthenticated, user, activeTheme, dispatch]);

  useEffect(() => {
    const getTheme = async () => {
      console.log(user?.business);
    if(user && user.business) {

     await dispatch(getDashboardTheme({ businessId: user.business.id })).unwrap();
     navigate("/");
    }
    }
      getTheme();
  },[user, isAuthenticated]);
  const { businessThemeRaw } = useSelector((state: RootState) => state.theme_slice);
  
  // Inside your Header2 component
const getLogoComponent = () => {
  // PRIORITY 1: Business theme logo from uploaded theme
  if (theme?.colorSchema?.logo?.main?.light) {
    //console.log('Using business theme logo:', theme.colorSchema.logo.main.light);
    return (
      <img 
        src={theme?.colorSchema?.logo?.main?.light}
        alt="Business logo"
        width={theme?.colorSchema?.logo?.main?.style?.width ? theme.colorSchema.logo.main.style.width  : 170}
          height={theme?.colorSchema?.logo?.main?.style?.height ? theme.colorSchema.logo.main.style.height  : 75}
        style={{ objectFit: 'contain' }}
        onError={(e) => {
          console.warn('Failed to load business logo, falling back to static');
          e.currentTarget.style.display = 'none';
        }}
      />
    );
  }

  // PRIORITY 2: Static logos based on activeTheme
  if (activeTheme === "elisyan") {
    return <LightLogoElisyan width={75} height={75} />;
  }

  if (activeTheme === "sopher") {
    return <LightLogoSopher width={75} height={75} />;
  }
  
  if (activeTheme === "sopheraccounting") {
    return <LightLogoSopherAcounting width={170} height={100} />;
  }
  
  if (activeTheme === "olympe") {
    return <LightLogoOlympe width={170} height={75} />;
  }
  
  if (activeTheme === "adambenedict") {
    return <LightLogoAdamBenedict width={170} height={75} />;
  }
  
  if (activeTheme === "aurum") {
    return <LightLogoAurum width={170} height={75} />;
  }
  
  // Default fallback
  return <LightLogoElisyan width={170} height={100} />;
};

  return (
    <div className={`${classes?.container} ${classes?.containerCenter}`}>
      {getLogoComponent()}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          marginTop: 16,
          marginBottom: 15,
        }}
      >
        <h2
          style={{
            fontSize: "22px",
            color: "#333333",
            fontWeight: "bold",
            textAlign: "center",
            margin: 0,
            whiteSpace: "nowrap",
          }}
        >
          {businessThemeRaw?.text.en.loginScreen}
        </h2>
      </div>

      <p
        style={{
          // fontFamily: "Gilroy-SemiBold",
          fontSize: "16px",
          color: "#333333",
          fontWeight: "normal",
          // border: "1px solid #ccc",
          marginTop: 2,
        }}
      >
        Log in to your account
      </p>
      <div>
        <LogInSignUpInput
          placeholder={"email"}
          value={email}
          onChangeText={(value) => {
            setEmail(value.trim());
            setEmailError(null);
            dispatch(setError(undefined));
          }}
          // showToggle={true}
          // secureTextEntry={true}
        />
        {emailError && <p className={classes?.error}>{emailError}</p>}
        <LogInSignUpInput
          placeholder={"password"}
          value={password}
          onChangeText={(value) => {
            setPassword(value.trim());
            setPasswordError(null);
            dispatch(setError(undefined));
          }}
          showToggle={true}
          secureTextEntry={true}
        />
        {passwordError && <p className={classes?.error}>{passwordError}</p>}
        <CustomButton
          title={loading ? "Logging in..." : "Login"}
          name="login"
          handleClick={handleLogin}
          disabled={false}
          loading={loading}
        />
        <p style={{ textAlign: "center" }}>
          {businessThemeRaw?.text.en.loginScreenRegister}
        </p>{" "}
        <a
          href="https://elisyanwealth.com/contact-us/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textAlign: "center",
            fontWeight: "bold",
            display: "block",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          Contact Us
        </a>
        {error && <p className={classes?.error}>{error.toString()}</p>}
      </div>
    </div>
  );
}

export default Login;
